import React, { useState } from 'react'
import Cookies from 'js-cookie';
import Sheet from '@mui/joy/Sheet';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import MailIcon from '@mui/icons-material/Mail'
import LoadingIcon from '../../common/LoadingIcon';
import ToastMessage from '../../common/ToastMessage';
import useScreenWidth from '../../store/useScreenWidth';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { EndPoints } from '../../utils/apiEndpoints';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../store/useUserStore';
import { StorageItems } from '../../utils/storageItems';
import { FieldErrors } from '../../domain/helpers/Errors';
import { darkModeBackgroud } from '../../utils/constants';
import { validateSchema } from '../../common/ValidateSchema';
import { useLanguageStore } from '../../store/useLanguageStore';
import { useDarkModeStore } from '../../store/useDarkModeStore';
import { sendEmailConfirmation } from '../../services/LoginService';
import { forgotPasswordSchema } from '../../domain/ValidationSchemas/ForgotPassword';

export const VerifyEmail = () => {
    const isSmallScreen = useScreenWidth();
    const { user, setUser } = useUserStore();
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();

    const navigate = useNavigate();
    const [errors, setErrors] = useState<FieldErrors>({});
    const [loading, setLoading] = useState<boolean>(false);

    const email = user && user.email ? user.email : '';

    const sheetCss = {
        my: 15,
        py: 4,
        gap: 0,
        px: '6%',
        mx: 'auto',
        display: 'flex',
        borderRadius: 'md',
        flexDirection: 'column',
        width: isSmallScreen ? '90%' : '45%',
        boxShadow: '8px 8px 30px rgba(0, 0, 0, 0.2)',
        background: darkMode ? darkModeBackgroud : 'white'
    };

    const handleSubmit = async () => {
        const isValid = validateSchema(forgotPasswordSchema, { email });

        setErrors(isValid.errors);
        if (!isValid.result) return;
        setLoading(true);
        try {
            await sendEmailConfirmation(email);
            ToastMessage.Success(language['ToastForgotPassword']);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const handleSignOut = () => {
        setUser(null);
        Cookies.remove(StorageItems.TOKEN);
        Cookies.remove(StorageItems.REFRESHTOKEN);
        navigate(EndPoints.LOGIN);
    }

    return (
        <div className='w-100 h-100'>
            <Sheet sx={sheetCss}>
                <div className={`${!isSmallScreen && 'ms-5 me-5'}`}>
                    <Typography
                        component="div"
                        className={`text-center fw-bold fs-2 mt-2 mb-3 ${darkMode && 'text-white'}`}
                    >
                        <MailIcon
                            sx={{
                                width: 55,
                                height: 55,
                                padding: 1.2,
                                color: 'white',
                                marginBottom: 2,
                                borderRadius: '50%',
                                border: '5px solid #bfbcf5',
                                background: 'var(--btn-theme-background)',
                            }}
                        />
                    </Typography>
                    <Typography
                        component="div"
                        className={`text-center fw-bold mt-2 mb-3 ${isSmallScreen ? 'fs-4' : 'fs-2'}`}
                        style={{ color: 'var(--text-theme-color)' }}
                    >
                        {language['VerifyEmailAddress']}
                    </Typography>
                    <Typography
                        component="div"
                        className='text-center mb-1'
                        style={{ fontSize: isSmallScreen ? '.8rem' : '1rem' }}
                    >
                        {language['VerifyEmailParagraph1']}
                    </Typography>
                    <Typography
                        component="div"
                        className={`text-center fw-bold ${isSmallScreen ? 'fs-6' : 'fs-5'}`}
                    >
                        {user && user.email ? user.email : ''}
                    </Typography>
                    <Typography
                        component="div"
                        className='text-center mb-1 mt-4'
                        style={{ fontSize: isSmallScreen ? '.8rem' : '1rem' }}
                    >
                        {language['VerifyEmailParagraph2']}
                    </Typography>
                    <Typography
                        component="div"
                        className='text-center mb-1 mt-4'
                        style={{ fontSize: isSmallScreen ? '.8rem' : '1rem' }}
                    >
                        {language['VerifyEmailParagraph3']}
                    </Typography>

                    <div
                        className='w-100 gap-2 mt-5 mb-2 d-flex align-items-center justify-content-center'
                    >
                        <Button
                            type='submit'
                            className="w-50 pt-3 pb-3"
                            onClick={handleSubmit}
                            sx={{
                                color: 'white',
                                fontSize: '16px',
                                width: '150px !important',
                                minWidth: '150px !important',
                                background: 'var(--btn-theme-background)',
                                '&:hover': { background: '#bfbcf' }
                            }}
                        >
                            {loading ? <LoadingIcon width={25} color='white' /> : language['VerificationEmail2']}
                        </Button>
                        <Button
                            type='submit'
                            className="pt-3 pb-3 ps-3 pe-3 text-nowrap"
                            onClick={handleSignOut}
                            sx={{
                                color: 'white',
                                fontSize: '16px',
                                width: 'fit-content',
                                background: 'var(--btn-theme-background)',
                                '&:hover': { background: '#bfbcf' }
                            }}
                        >
                            <ExitToAppIcon className='me-2' />
                            {language['SignOut']}
                        </Button>
                    </div>
                </div>

            </Sheet>
        </div>
    );
}
export default VerifyEmail;